export default class TextFragmentProcessor {

	static init() {
		//test for fancy fragment directive
		let myHash = decodeURIComponent(window.location.hash);

		if (/^#s\[\]=.+$/.test(myHash)) {
			let highlightDirective = myHash.replace('#', '').replace(/s\[\]=/g, '');
			let termArray = highlightDirective.split('|');
			const bodyElement = document.querySelector('body');
			// wrap the terms
			termArray.forEach(term => {
				this.wrapTextWithSpan(bodyElement, term.toLowerCase());
			});

			window.addEventListener('load', (event) => {
  				setTimeout(() => {
					this.setScrollEvent();
				}, 500);
			});
		}
	}


	static setScrollEvent() {
		// focus first highlight instance
		const allHighlights = document.querySelectorAll('.highlight');
		let currentHighlight = 0;
		allHighlights[currentHighlight].scrollIntoView({
			block: 'center'
		});

		document.addEventListener('keydown', function (event) {
		// this event is conflicting with slideshow will need to look into this
		// 2025-01-23 actually not sure about conflict—now working fine
// 			console.log(event);
// 			console.log(event.key);
			if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
				if (event.key === 'ArrowRight') {
					currentHighlight = (currentHighlight + 1) % allHighlights.length;
				} else {
					currentHighlight = (currentHighlight - 1) % allHighlights.length;
					currentHighlight = currentHighlight === -1 ? allHighlights.length - 1 : currentHighlight;
				}
				allHighlights[currentHighlight].scrollIntoView({
					block: 'center'
				});
			}
		});
	}

	static wrapTextWithSpan(element, searchText) {
		// Get all text nodes within the element
		const textNodes = this.getTextNodes(element);

		// Loop through each text node
		textNodes.forEach(node => {
			// Check if the text node contains the search text
			if (node.textContent.toLowerCase().includes(searchText)) {
				// Create a new span element
				const span = document.createElement('span');

				// Set the class or style for the span
				span.classList.add('highlight'); // Or any other class you want

				// Split the text node and wrap the matching text with the span
				const text = node.textContent;
				const parts = text.split(new RegExp(`(${searchText})`, 'gi'));
				const newNode = document.createDocumentFragment();

				parts.forEach(part => {
					if (part.toLowerCase() === searchText) {
						const newSpan = span.cloneNode();
						newSpan.textContent = part;
						newNode.appendChild(newSpan);
					} else {
						newNode.appendChild(document.createTextNode(part));
					}
				});

				// Replace the original text node with the new fragment
				node.parentNode.replaceChild(newNode, node);
			}
		});
	}

	static getTextNodes(node) {
		const textNodes = [];
		if (node.nodeType === Node.TEXT_NODE) {
			textNodes.push(node);
		} else {
			for (let i = 0; i < node.childNodes.length; i++) {
				textNodes.push(...this.getTextNodes(node.childNodes[i]));
			}
		}
		return textNodes;
	}



}